<template>
  <div>
    <slot :selectedOptions="selectedOptions" :orientation="orientation"></slot>
  </div>
</template>
<script>
export default {
  name: "bc-checkbox-option-slot",
  props: {
    selectedOptions: {
      type: Array,
      default: null,
    },
    orientation: {
      type: String,
      default: null,
    },
  },
  render() {
    return this.$slots.default;
  },
};
</script>